import React from 'react';
import {
  Bar,
  BarChart,
  CartesianGrid,
  LabelList,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { Box } from '@mui/material';
import MedalLegend from './MedalLegend';
import { GraphColors } from '../../../common/helper';

interface Props {
  title?: string;
  lgNumber?: number;
  xsNumber?: number;
  tooltipText?: any;
  data?: any[];
  from?: string;
  dateInfo?: string;
  showValue?: boolean;
  showTooltip?: boolean;
  rangeDate?: any;
  isToggle?: boolean;
  toggleType?: { type: string; value: 1 | 2 };
  onChangeToggle?: (type: string, newValue: 1 | 2) => void;
  loading?: boolean;
}

export const SwStackedBarChart: React.FC<Props> = ({
  title,
  lgNumber = 4,
  xsNumber = 6,
  tooltipText,
  data,
  from,
  dateInfo,
  showValue = true,
  showTooltip = true,
  rangeDate,
  toggleType,
  onChangeToggle,
  loading,
}) => {
  const keys = ['gold', 'silver', 'bronze', 'empty'];

  const toPercent = (decimal: number, fixed: number = 0) =>
    `${(decimal * 100).toFixed(fixed)}%`;

  const getPercent = (value: number, total: number) => {
    const ratio = total > 0 ? value / total : 0;
    return toPercent(ratio, 2);
  };

  const renderBars = () =>
    keys.map((item, index) => (
      <Bar key={index} dataKey={item} stackId='a' fill={GraphColors[index]} />
    ));

  return (
    <>
      {data && data.length > 0 ? (
        <ResponsiveContainer width='100%' height='100%'>
          <BarChart
            width={500}
            height={300}
            data={data}
            margin={{
              top: 20,
              right: 30,
              left: 20,
              bottom: 5,
            }}
          >
            <CartesianGrid strokeDasharray='4 4' />
            <XAxis dataKey='name' padding={{ left: 30, right: 30 }} />
            <YAxis />
            <Tooltip />
            <Legend content={<MedalLegend />} />
            {renderBars()}
          </BarChart>
        </ResponsiveContainer>
      ) : (
        <Box
          className='no-data'
          sx={{ width: '100%', height: '100%', paddingTop: 0 }}
        >
          <div>데이터가 없습니다.</div>
        </Box>
      )}
    </>
  );
};
